<div class="modal-dialog modal-lg">
    <div class="modal-content">
    
    <!-- Modal Header -->
    <div class="modal-header">
        <h4 class="modal-title">Importação de registros em massa</h4>
        <button type="button" class="close" data-dismiss="modal">&times;</button>
    </div>
    
    <!-- Modal body -->
    <div class="modal-body">
        <p>Para importar a blacklist, selecionei abaixo o arquivo (.csv) e em seguida confira os dados.</p>
        
        <input type="file" #importar class="form-control" accept=".csv" (change)="importarCsv($event)">
        <div *ngIf="newBlacklistArray.length > 0" class="mt-2">
            <table class="table table-bordered table-sm table-striped">
                <thead>
                    <tr>
                        <th>Login</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let c of newBlacklistArray">
                        <td>{{c.login}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <hr>
        <!-- <small>Se necessário faça o download do arquivo modelo aqui
            <button class="btn btn-light ml-auto mr-2 px-2 py-0 ml-2" pTooltip="Baixar modelo de documento">
                <i class="fas fa-download fa-xs"></i>
            </button>
        </small> -->
        <button class="btn-custom btn btn-success" (click)="importarList()">
            Salvar
        </button> 
        <button class="btn-custom btn btn-light mr-2" (click)="zerarInputFile(importar)">
            Descartar arquivo
        </button>
    </div>
    </div>
</div>